import InputError from '../../../../common/components/alerts/InputError';
import {WithChildren} from '../../../../common/helpers';
import Label from './Label';

interface Props {
	label: string;
	isInvalid?: boolean;
	error?: string;
	required?: boolean;
}

export default function FormControl({label, children, isInvalid, error, required = false}: Props & WithChildren) {
	return (
		<div className='mb-4 sm:mb-5 lg:mb-9 flex flex-col'>
			<Label text={label} required={required} />
			{children}

			{isInvalid && (
				<div className='mt-1'>
					<InputError error={error} />
				</div>
			)}
		</div>
	);
}
